/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:07:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-22 14:31:27
 */
/**
 * 项目中的正则
 */

// 账号的正则 【 3到12位（字母，数字，下划线，减号）】
export const accReg = /^[a-zA-Z0-9_-]{3,12}$/;

// 密码的正则 【 3到12位（字母，数字，下划线，减号）】
export const pwdReg = /^[a-zA-Z0-9_-]{3,12}$/;

export const youbian = /^[0-9]{6}$/;

export const telephone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;

export const passcheck = /^[a-zA-Z][a-zA-Z0-9_-]{3,15}$/;

export const idCard = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
export function phone(rule, value, callback) {
    var regex = /^1\d{10}$/
    if (!regex.test(value)) {
        callback(new Error('请输入正确的手机号'));
    } else {
        callback();
    }
}

export function pass(rule, v, callback){  
        var numasc = 0;  
        var charasc = 0;  
        var otherasc = 0;  
            if(0==v.length){  
                callback(new Error('新密码不符合要求，请重新设置'));
           }else if(v.length<12 || v.length>15){  
                callback(new Error('新密码不符合要求，请重新设置'));
            }else{  
                for (var i = 0; i < v.length; i++) {  
                    var asciiNumber = v.substr(i, 1).charCodeAt();  
                    if (asciiNumber >= 48 && asciiNumber <= 57) {  
                        numasc += 1;  
                   }  
                    if ((asciiNumber >= 65 && asciiNumber <= 90)||(asciiNumber >= 97 && asciiNumber <= 122)) {  
                        charasc += 1;  
                    }  
                    if ((asciiNumber >= 33 && asciiNumber <= 47)||(asciiNumber >= 58 && asciiNumber <= 64)||(asciiNumber >= 91 && asciiNumber <= 96)||(asciiNumber >= 123 && asciiNumber <= 126)) {  
                       otherasc += 1;  
                   }  
               }  
               if(0==numasc)  {  
                    callback(new Error('新密码不符合要求，请重新设置')); 
                }else if(0==charasc){  
                    callback(new Error('新密码不符合要求，请重新设置'));   
                }else if(0==otherasc){  
                   callback(new Error('新密码不符合要求，请重新设置'));   
               }else{  
                    callback(); 
                } 
            } 
    };
export function regEmail(rule, value, callback) {
    var regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
    if (!regex.test(value)) {
        callback(new Error('请输入正确邮箱'));
    } else {
        callback();
    }
}

export function idNumber(rule, value, callback) {
    var regex = idCard;
    if (!regex.test(value)) {
        callback(new Error('请输入正确身份证号'));
    } else {
        callback();
    }
}

export function telephoneNumber(rule, value, callback) {
    var regex = telephone;
    if (!regex.test(value)) {
        callback(new Error('请输入正确的座机号'));
    } else {
        callback();
    }
}

export function youbianCode(rule, value, callback) {
    var regex = youbian;
    if (!regex.test(value)) {
        callback(new Error('请输入正确邮政编码'));
    } else {
        callback();
    }
}